export default __webpack_public_path__ + "media/images/user_photos/156-6b8e49a1f685ad00b4cfdee3fcd9bbd2.jpg";